import {
  BreakLine,
  Card,
  CardSectionHeader,
  CheckPoint,
  ConnectingCheckPoints,
  Loader,
  RadioButtons,
  UploadFile,
} from "@egovernments/digit-ui-react-components";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState, Fragment } from "react";
import { Tab, Tabs, Box } from "@mui/material";
import TabPanel from "@egovernments/digit-ui-module-obps/src/pageComponents/TabPanel";
import TLCaption from "../../ApplicationDetails/components/TLCaption";
import { useParams, useHistory } from "react-router-dom";
import DemoParinted from "../../ApplicationDetails/components/RichTextArea";
import Addmoreinput from "../Complaince/Compliances";
import { styled } from "@mui/styles";
import EmployeeComponent from "../../ApplicationDetails/RoleAccessProfessional/Employer";
import Architect from "../../ApplicationDetails/RoleAccessProfessional/Architect";
// import Structural from "../../ApplicationDetails/RoleAccess12/StructuralEngineer";
import axios from "axios";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";
import { Toast } from "@egovernments/digit-ui-react-components";
import { Button, Dialog, DialogActions, DialogContentText, DialogTitle } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DialogContent from "@mui/material/DialogContent";
import Swal from "sweetalert2";
import LTPCheckList from "@egovernments/digit-ui-module-obps/src/pages/citizen/TCPForms/formComponents/registration/LTPChecklist";
import { useSelector } from "react-redux";
import NewsTicker from "@egovernments/digit-ui-module-core/src/pages/citizen/Home/LandingPage/NewsTicker";
import LTPSummary from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/formComponents/ltp-registration/Summary/LTPSummary";

const StyledTabPanel = styled(TabPanel)(() => ({
  "& .MuiBox-root": { padding: 0 },
}));

const typeOfLandVolvedList = [
  {
    active: true,
    code: "YES",
    name: "Yes",
    i18nKey: "COMMON_MASTERS_YES",
  },
  {
    active: true,
    code: "NO",
    name: "No",
    i18nKey: "COMMON_MASTERS_NO",
  },
];
const ProfessionalFormSummary = ({
  formData,
  businessService,
  action,
  edcrDetails,
  setOnAddComments,
  onActionSelect,
  showTimeLine = true,
  applicationData,
  collectionBillDetails,
  workflowDetails,
  timelineStatusPrefix,
  isDataLoading,
  statusAttribute = "status",
  submitAction,
  actionData,
  moduleCode,
}) => {
  const [smShow, setSmShow] = useState(false);
  const [currentTab, setCurrentTab] = useState("0");
  const [file, setFile] = useState(null);
  const { id } = useParams();
  const history = useHistory();
  const [typeOfLandVolved, setTypeOfLandVolved] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const [developerRemarks, setDeveloperRemarks] = useState("");
  const [currentAction, setCurrentAction] = useState(null);
  const [currentActionCertification, setCurrentActionCertification] = useState(null);
  const [showTakeAction, setShowTakeAction] = useState("");
  const [structureCertificateUrl, setStructureCertificateUrl] = useState("");
  const [structureCertificateId, setStructureCertificateId] = useState("");
  const [showToast, setShowToast] = useState(null);
  const [roleFormCode, setRoleFormCode] = useState(null);
  const [open, setOpen] = useState(false);

  const [openApplicantPopup, setOpenApplicantPopup] = useState(false);
  const closeToast = () => setShowToast(null);
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const { t } = useTranslation();
  const stateId = Digit.ULBService.getStateId();
  const tenantId = stateId;
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "Registration");
  const appType = formData?.applicationType;
  const authToken = Digit.UserService.getUser()?.access_token || null;
  const userInfo = Digit.UserService.getUser()?.info || {};
  const userRolesArray = userInfo?.roles.filter((user) => user.code !== "EMPLOYEE");
  const BusinessService = formData?.businessService === `BPA_${appType?.replace("_", "")}` ? `BPA.${appType}_FEE` : `BPA.${appType}_FEE_UD`;
  const reduxFormData = useSelector((state) => state?.ltpChecklist);
  const allValuesNull = (data) => Object.values(data || {}).every((value) => value === null);
  const isNodal = userRolesArray?.some((e) => e?.code === "Nodal Officer");

  const docs = formData?.applicationData?.tradeLicenseDetail?.applicationDocuments || {};

  const documents = typeof docs === "object" && !Array.isArray(docs) ? Object.values(docs) : docs;
  formData.documents = documents;
  let user = Digit.UserService.getUser();
  const userRoles = user?.info?.roles?.map((e) => e.code);
  let isbelow = formData?.plotArea < 2500;
  const isTCP = userRoles.includes("TCP_HQ") || userRoles.includes("TCP");
  let actions = workflowDetails?.data?.actionState?.nextActions?.filter((e) => {
    if (isbelow && isTCP && (e.action === "SEND_TO_STP" || e.action === "FORWARD") && formData?.businessService === "BPA") {
      return false;
    } else if (
      !isbelow &&
      isTCP &&
      (e.action === "APPROVE" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECT" || e.action === "PROVISIONALLY_APPROVAL") &&
      formData?.businessService === "BPA"
    ) {
      return false;
    }
    return userRoles.some((role) => e.roles?.includes(role)) || !e.roles;
  });
  //
  const tablist = [
    { label: "Application Summary", color: "green" },
    { label: "WF_TAKE_ACTION", color: "red" },
    { label: "ES_APPLICATION_DETAILS_APPLICATION_ALL_REMARKS", color: "green" },
    user?.info?.type === "EMPLOYEE" ? { label: "WF_NOC_LTP", color: "green" } : null, // Ensure no `false`
  ].filter(Boolean);
  // SITE_INSPECTION_REPORT
  const actionObject = actions?.[0]?.action;
  const currentTime = new Date().getTime();
  const hoursDifference = (currentTime - actionObject?.createdTime) / (1000 * 60 * 60);
  const twentyFourHoursPassed = hoursDifference >= 24;

  setOnAddComments(developerRemarks);

  const onRadioActionSelect = (value) => {
    setCurrentAction(value);
  };

  const selectedValueSelect = (value) => {
    setTypeOfLandVolved(value);
  };
  let improvedDoc = [];
  formData?.PrevStateDocuments?.map((preDoc) => {
    improvedDoc.push({ ...preDoc, module: "OBPS" });
  });
  documents?.map((appDoc) => {
    improvedDoc.push({ ...appDoc, module: "OBPS" });
  });

  formData?.PrevStateNocDocuments?.map((preNocDoc) => {
    improvedDoc.push({ ...preNocDoc, module: "NOC" });
  });
  formData?.nocDocuments?.nocDocuments?.map((nocDoc) => {
    improvedDoc.push({ ...nocDoc, module: "NOC" });
  });

  const { data: pdfDetails, isLoading: pdfLoading } = Digit.Hooks.useDocumentSearch(improvedDoc, { enabled: improvedDoc?.length > 0 ? true : false });

  let applicationDocs = [],
    nocAppDocs = [];
  if (pdfDetails?.pdfFiles?.length > 0) {
    pdfDetails?.pdfFiles?.map((pdfAppDoc) => {
      if (pdfAppDoc?.module == "OBPS") applicationDocs.push(pdfAppDoc);
      if (pdfAppDoc?.module == "NOC") nocAppDocs.push(pdfAppDoc);
    });
  }

  let consumerCode = formData?.applicationNo;
  const fetchBillParams = { consumerCode };

  const { data: paymentDetails } = Digit.Hooks.useFetchBillsForBuissnessService(
    { businessService: BusinessService, ...fetchBillParams, tenantId: stateId },
    {
      enabled: consumerCode ? true : false,
      retry: false,
    }
  );
  const totalAmount = formData?.paymentDetails?.bill?.billDetails[0]?.amount || paymentDetails?.Bill?.[0]?.billDetails[0]?.amount;
  //Applicant Popup submit
  const handleModal = () => {
    setOpenApplicantPopup(false);
    setTimeout(() => {
      history.push({
        pathname: `/digit-ui/citizen/profile`,
      });
    }, 2000);
  };

  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
  };
  const isEditApplication = window.location.href.includes("editApplication");
  const sendbacktocitizenApp = window.location.href.includes("sendbacktocitizen");
  let routeLink = `/digit-ui/citizen/obps/form11/${formData?.applicationType?.toLowerCase()}/${formData?.serviceType?.toLowerCase()}`;
  if (isEditApplication) routeLink = `/digit-ui/citizen/obps/editApplication/form11/${formData?.tenantId}/${formData?.applicationNo}`;
  if (sendbacktocitizenApp) routeLink = `/digit-ui/citizen/obps/sendbacktocitizen/form11/${formData?.tenantId}/${formData?.applicationNo}`;
  ////
  function OpenImage(imageSource, index, thumbnailsToShow) {
    window.open(thumbnailsToShow?.fullImage?.[0], "_blank");
  }
  const getTimelineCaptions = (checkpoint) => {
    if (checkpoint.state === "OPEN" || (checkpoint.status === "INITIATED" && !window.location.href.includes("/obps/"))) {
      const caption = {
        date: Digit.DateUtils.ConvertTimestampToDate(applicationData?.auditDetails?.createdTime),
        source: applicationData?.channel || "",
      };
      return <TLCaption data={caption} />;
    } else if (window.location.href.includes("/obps/") || window.location.href.includes("/noc/")) {
      const caption = {
        date: checkpoint?.auditDetails?.lastModified,
        name: checkpoint?.assignes?.[0]?.name,
        mobileNumber: checkpoint?.assignes?.[0]?.mobileNumber,
        comment: t(checkpoint?.comment),
        wfComment: checkpoint.wfComment,
        thumbnailsToShow: checkpoint?.thumbnailsToShow,
      };
      return <TLCaption data={caption} OpenImage={OpenImage} />;
    } else {
      const caption = {
        date: Digit.DateUtils?.ConvertTimestampToDate(applicationData?.auditDetails?.lastModifiedTime),
        name: checkpoint?.assignes?.[0]?.name,
        wfComment: checkpoint?.wfComment,
        mobileNumber: checkpoint?.assignes?.[0]?.mobileNumber,
      };
      return <TLCaption data={caption} />;
    }
  };
  function routeTo(jumpTo) {
    location.href = jumpTo;
  }

  const registrationActions = workflowDetails?.data?.nextActions;
  const professionalType = applicationData?.tradeLicenseDetail?.tradeUnits?.[0]?.tradeType;
  const tradeTypeArr = ["ARCHITECT.CLASSA", "SUPERVISOR.CLASSA"];
  const filteredRegistrationAction = registrationActions?.filter((action) => {
    if (action.action === "SENDBACK_TO_AO" && tradeTypeArr.includes(professionalType)) {
      return false;
    }
    return true;
  });

  ///////////////////////////////////

  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file?.type && !allowedFileTypesRegex.test(file?.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            const response = await Digit.UploadServices.Filestorage("OBPS", file, Digit.ULBService.getStateId() || tenantId?.split(".")[0]);
            if (response?.data?.files?.length > 0) {
              setUploadedFile(response?.data?.files[0]?.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  useEffect(() => {
    if (["APPROVED", "FORWARD_TO_NODAL"].includes(currentAction?.action)) {
      setOpen(true);
    }
  }, [currentAction]);

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (!userRoles) return;
    if (
      [
        "BPA_ARCHITECT",
        "BPA_TOWNPLANNER",
        "BPA_ENGINEER",
        "BPA_ARCHITECT_ASSISTANT",
        "BPA_ENGINEER_DIPLOMA",
        "BPA_DRAUGHTSMAN",
        "BPA_SURVEYOR",
      ].includes(userRoles)
    ) {
      setRoleFormCode("true");
    }
  }, [userRoles]);

  //////////////
  const getInspectionDocs = (docs) => {
    let refinedDocs = [];
    docs &&
      docs.map((doc, ind) => {
        refinedDocs.push({
          documentType: (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", "."),
          fileStoreId: doc.fileStoreId,
          fileStore: doc.fileStoreId,
          fileName: "",
          dropDownValues: {
            value: (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", "."),
          },
        });
      });
    return refinedDocs;
  };

  const getQuestion = (data) => {
    let refinedQues = [];
    var i;
    for (i = 0; i < data?.questionLength; i++) {
      refinedQues.push({
        remarks: data[`Remarks_${i}`],
        question: data?.questionList[i].question,
        value: data?.[`question_${i}`]?.code,
      });
    }
    return refinedQues;
  };

  const getfeildInspection = (data) => {
    let formdata = [],
      inspectionOb = [];

    if (data?.additionalDetails?.fieldinspection_pending?.length > 0) {
      inspectionOb = data?.additionalDetails?.fieldinspection_pending;
    }

    if (data.status == "FIELDINSPECTION_INPROGRESS") {
      formdata = JSON.parse(sessionStorage.getItem("INSPECTION_DATA"));
      formdata?.length > 0 &&
        formdata.map((ob, ind) => {
          inspectionOb.push({
            docs: getInspectionDocs(ob.Documents),
            date: ob.InspectionDate,
            questions: getQuestion(ob),
            time: ob?.InspectionTime,
          });
        });
      inspectionOb = inspectionOb.filter((ob) => ob.docs && ob.docs.length > 0);
    } else {
      sessionStorage.removeItem("INSPECTION_DATA");
    }

    let fieldinspection_pending = [...inspectionOb];
    return fieldinspection_pending;
  };

  const getDocuments = () => {
    let documentsformdata = JSON.parse(sessionStorage.getItem("BPA_DOCUMENTS"));
    let documentList = [];
    documentsformdata?.map((doc) => {
      if (doc?.uploadedDocuments?.[0]?.values?.length > 0) documentList = [...documentList, ...doc?.uploadedDocuments?.[0]?.values];
      if (doc?.newUploadedDocs?.length > 0) documentList = [...documentList, ...doc?.newUploadedDocs];
    });
    return documentList;
  };

  // const getPendingApprovals = () => {
  //   const approvals = Digit.SessionStorage.get("OBPS_APPROVAL_CHECKS");
  //   const newApprovals = Digit.SessionStorage.get("OBPS_NEW_APPROVALS");
  //   let result = approvals?.reduce((acc, approval) => approval?.checked ? acc.push(approval?.label) && acc : acc, []);
  //   result = result?.concat(newApprovals !== null ? newApprovals.filter(ob => ob.label !== "").map(approval => approval?.label) : []);
  //   return result;
  // }

  async function submit(data) {
    console.log(userRolesArray, isNodal, "userRolesssArray");
    if (currentAction?.action === "ISSUE_CERTIFICATE_APPROVAL") {
      onActionSelect(currentAction);
    } else {
      if (isNodal && allValuesNull(reduxFormData)) {
        Swal.fire({
          title: "Checklist Required",
          text: `Please fill the checklist before Proceeding!`,
          icon: "error",
        });
        return 0;
      }

      // let workflow = { action: currentAction, comments: developerRemarks, businessService, moduleName: moduleCode };
      const additionalDetails = { ...formData?.applicationData, fieldinspection_pending: getfeildInspection(applicationData) };
      const workflow = {
        action: currentAction?.action,
        comment: developerRemarks,
        comments: developerRemarks,
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile
          ? [
              {
                documentType: currentAction + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      const appData = {
        ...applicationData,
        // documents: formData?.applicationData?.tradeLicenseDetail?.applicationDocuments ,
        additionalDetails,
        workflow,
        action: currentAction?.action,
        comment: developerRemarks,
        nocOtherDetails: reduxFormData,
        assignee: null,
        wfDocuments: uploadedFile
          ? [
              {
                documentType: currentAction + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      // submitAction({
      //   Licenses: [appData],
      // });
      //alert message
      let action = "";
      if (currentAction?.action === "FORWARD_TO_NODAL") {
        action = "Payment Verified";
      } else if (currentAction?.action === "REJECT") {
        action = "Rejected";
      } else if (currentAction?.action === "SENDBACK_TO_CITIZEN") {
        action = "Sent to Applicant";
      }
      try {
        const result = await submitAction({ Licenses: [appData] });
        // Show toast after the async operation is completed successfully
        Swal.fire({
          title: "Action Applied",
          text: `Application (${applicationData?.applicationNumber}) ${t(action)} Successfully!`,
          icon: "success",
        });
      } catch (error) {
        // Handle error case
        setShowToast({
          key: "true",
          error: true,
          message: `Failed to update the application. Please try again.`,
        });
        window.alert("Failed to update the application. Please try again.");
      }
    }
  }

  function structuralStabilitySubmit() {
    if (currentAction?.action === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE") {
      const additionalDetails = { ...applicationData?.additionalDetails, fieldinspection_pending: getfeildInspection(applicationData) };
      const workflow = {
        action: currentAction?.action,
        comment: developerRemarks,
        comments: developerRemarks,
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile
          ? [
              {
                documentType: currentAction + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      const appData = {
        ...applicationData,
        documents: formData?.documents,
        additionalDetails,
        workflow,
        structureCertificateUrl: structureCertificateUrl,
        structureCertificateId: structureCertificateId,
        action: currentAction?.action,
        comment: developerRemarks,
        assignee: null,
        wfDocuments: uploadedFile
          ? [
              {
                documentType: currentAction + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      submitAction({
        BPA: appData,
      });
    } else {
    }
  }
  async function approvalOfLetterSubmit(fileStoreId) {
    let currentAction = "APPROVED_WITH_LETTER";
    try {
      const additionalDetails = { ...formData?.applicationData, fieldinspection_pending: getfeildInspection(applicationData) };
      const workflow = {
        action: currentAction,
        comment: developerRemarks,
        comments: developerRemarks,
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile
          ? [
              {
                documentType: +" DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      const appData = {
        ...applicationData,
        // documents: formData?.applicationData?.tradeLicenseDetail?.applicationDocuments ,
        additionalDetails,
        workflow,
        action: currentAction,
        approvalLetterId: fileStoreId,
        comment: developerRemarks,
        assignee: null,
        wfDocuments: uploadedFile
          ? [
              {
                documentType: currentAction + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      const data = [{ ...appData }];
      updateApiCall.mutate(
        { Licenses: data },
        {
          onSuccess: async (result) => {
            if (result?.Licenses?.length > 0) {
              Swal.fire({
                title: "Action Applied",
                text: `Application (${result?.Licenses?.[0]?.applicationNumber}) Approved Successfully!`,
                icon: "success",
              }).then(() => {
                window.location.reload();
              });
              //history.push("/digit-ui/employee");
            }
          },
        }
      );
    } catch (error) {
      console.log(error);
    }
  }

  function handleChangePayment() {
    if (actions?.[0]?.action === "MAKE_PAYMENT") {
      try {
        const additionalDetails = { ...applicationData?.additionalDetails, fieldinspection_pending: getfeildInspection(applicationData) };
        const workflow = {
          action: "MAKE_PAYMENT",
          comment: "Payment Done",
          comments: "Payment Done",
          assignee: null,
          assignes: null,
          varificationDocuments: uploadedFile
            ? [
                {
                  documentType: actions + " DOC",
                  fileName: file?.name,
                  fileStoreId: uploadedFile,
                },
              ]
            : null,
        };
        const appData = {
          ...applicationData,
          documents: formData?.documents,
          additionalDetails,
          workflow,
          action: "MAKE_PAYMENT",
          comment: "Payment Done",
          assignee: null,
          wfDocuments: uploadedFile
            ? [
                {
                  documentType: actions + " DOC",
                  fileName: file?.name,
                  fileStoreId: uploadedFile,
                },
              ]
            : null,
        };

        Digit.OBPSService.update({ BPA: appData }, tenantId).then((result) => {
          if (result?.BPA?.length > 0) {
            setShowToast({
              key: "true",
              error: false,
              message: `Application (${result?.BPA?.[0]?.applicationNo}) Updated Successfully!`,
            });
            window.location.assign(
              `${
                window.location.origin
              }/digit-ui/citizen/payment/collect/${`bpa/${result?.BPA?.[0]?.applicationNo}/${tenantId}?tenantId=${tenantId}?flow=${result?.BPA?.[0]?.applicationType}`}`
            );
          }
        });
      } catch (error) {
        console.log("error", error);
      }
    }
    if (actions?.[0]?.action === "MAKE_PAYMENT_APPLICATION_FEE") {
      try {
        const additionalDetails = { ...applicationData?.additionalDetails, fieldinspection_pending: getfeildInspection(applicationData) };
        const workflow = {
          action: "MAKE_PAYMENT_APPLICATION_FEE",
          comment: "Payment Done",
          comments: "Payment Done",
          assignee: null,
          assignes: null,
          varificationDocuments: uploadedFile
            ? [
                {
                  documentType: actions + " DOC",
                  fileName: file?.name,
                  fileStoreId: uploadedFile,
                },
              ]
            : null,
        };
        const appData = {
          ...applicationData,
          documents: formData?.documents,
          additionalDetails,
          workflow,
          action: "MAKE_PAYMENT_APPLICATION_FEE",
          comment: "Payment Done",
          assignee: null,
          wfDocuments: uploadedFile
            ? [
                {
                  documentType: actions + " DOC",
                  fileName: file?.name,
                  fileStoreId: uploadedFile,
                },
              ]
            : null,
        };

        Digit.OBPSService.update({ BPA: appData }, tenantId).then((result) => {
          if (result?.BPA?.length > 0) {
            setShowToast({
              key: "true",
              error: false,
              message: `Application (${result?.BPA?.[0]?.applicationNo}) Updated Successfully!`,
            });
            window.location.assign(
              `${
                window.location.origin
              }/digit-ui/citizen/payment/collect/${`bpa/${result?.BPA?.[0]?.applicationNo}/${tenantId}?tenantId=${tenantId}?flow=${result?.BPA?.[0]?.applicationType}`}`
            );
          }
        });
      } catch (error) {
        console.log("error", error);
      }
    }
  }
  function handleChangePaymentTCP() {
    if (formData?.plotArea < 500) {
      try {
        const additionalDetails = { ...applicationData?.additionalDetails, fieldinspection_pending: getfeildInspection(applicationData) };
        const workflow = {
          action: "MAKE_PAYMENT",
          comment: "Payment Done",
          comments: "Payment Done",
          assignee: null,
          assignes: null,
          varificationDocuments: uploadedFile
            ? [
                {
                  documentType: actions + " DOC",
                  fileName: file?.name,
                  fileStoreId: uploadedFile,
                },
              ]
            : null,
        };
        const appData = {
          ...applicationData,
          documents: formData?.documents,
          additionalDetails,
          workflow,
          action: "MAKE_PAYMENT",
          comment: "Payment Done",
          assignee: null,
          wfDocuments: uploadedFile
            ? [
                {
                  documentType: actions + " DOC",
                  fileName: file?.name,
                  fileStoreId: uploadedFile,
                },
              ]
            : null,
        };

        Digit.OBPSService.update({ BPA: appData }, tenantId).then((result) => {
          if (result?.BPA?.length > 0) {
            setShowToast({
              key: "true",
              error: false,
              message: `Application (${result?.BPA?.[0]?.applicationNo}) Updated Successfully!`,
            });
            window.location.assign(
              `${
                window.location.origin
              }/digit-ui/citizen/payment/collect/${`bpa/${result?.BPA?.[0]?.applicationNo}/${tenantId}?tenantId=${tenantId}?flow=${result?.BPA?.[0]?.applicationType}`}`
            );
          }
        });
      } catch (error) {
        console.log("error", error);
      }
    }
  }
  function handleChangeForward() {
    if (actions?.[0]?.action === "FORWARD_TO_DEPARTMENT") {
      try {
        const additionalDetails = { ...applicationData?.additionalDetails, fieldinspection_pending: getfeildInspection(applicationData) };
        const workflow = {
          action: "FORWARD_TO_DEPARTMENT",
          comment: "Forward to Departemts",
          comments: "Forward to Departemts",
          assignee: null,
          assignes: null,
          varificationDocuments: uploadedFile
            ? [
                {
                  documentType: actions + " DOC",
                  fileName: file?.name,
                  fileStoreId: uploadedFile,
                },
              ]
            : null,
        };
        const appData = {
          ...applicationData,
          documents: formData?.documents,
          additionalDetails,
          workflow,
          action: "FORWARD_TO_DEPARTMENT",
          comment: "Forward to Departemts",
          assignee: null,
          wfDocuments: uploadedFile
            ? [
                {
                  documentType: actions + " DOC",
                  fileName: file?.name,
                  fileStoreId: uploadedFile,
                },
              ]
            : null,
        };
        /////
        Digit.OBPSService.update({ BPA: appData }, tenantId).then((result) => {
          if (result?.BPA?.length > 0) {
            setShowToast({
              key: "true",
              error: false,
              message: `Application (${result?.BPA?.[0]?.applicationNo}) Updated Successfully!`,
            });
            setOpenApplicantPopup(true);
            // window.location.assign(`${window.location.origin}/digit-ui/citizen/payment/collect/${`bpa/${result?.BPA?.[0]?.applicationNo}/${tenantId}?tenantId=${tenantId}?flow=${result?.BPA?.[0]?.applicationType}`}`);
          }
        });
      } catch (error) {
        console.log("error", error);
      }
    }
    if (actions?.[0]?.action === "UPLOAD_SITE_INSPECTION_REPORT") {
      try {
        const additionalDetails = { ...applicationData?.additionalDetails, fieldinspection_pending: getfeildInspection(applicationData) };
        const workflow = {
          action: "UPLOAD_SITE_INSPECTION_REPORT",
          comment: "Approval",
          comments: "Approval",
          assignee: null,
          assignes: null,
          varificationDocuments: uploadedFile
            ? [
                {
                  documentType: actions + " DOC",
                  fileName: file?.name,
                  fileStoreId: uploadedFile,
                },
              ]
            : null,
        };
        const appData = {
          ...applicationData,
          documents: formData?.documents,
          additionalDetails,
          workflow,
          action: "UPLOAD_SITE_INSPECTION_REPORT",
          comment: "Approval",
          assignee: null,
          wfDocuments: uploadedFile
            ? [
                {
                  documentType: actions + " DOC",
                  fileName: file?.name,
                  fileStoreId: uploadedFile,
                },
              ]
            : null,
        };
        /////
        Digit.OBPSService.update({ BPA: appData }, tenantId).then((result) => {
          if (result?.BPA?.length > 0) {
            setShowToast({
              key: "true",
              error: false,
              message: `Application (${result?.BPA?.[0]?.applicationNo}) Updated Successfully!`,
            });
            setOpenApplicantPopup(true);
            // window.location.assign(`${window.location.origin}/digit-ui/citizen/payment/collect/${`bpa/${result?.BPA?.[0]?.applicationNo}/${tenantId}?tenantId=${tenantId}?flow=${result?.BPA?.[0]?.applicationType}`}`);
          }
        });
      } catch (error) {
        console.log("error", error);
      }
    }
  }

  const approvalOfLetterPdf = async (currentAction) => {
    try {
      const additionalDetails = { ...formData?.applicationData, fieldinspection_pending: getfeildInspection(applicationData) };
      const workflow = {
        action: currentAction?.action,
        comment: developerRemarks,
        comments: developerRemarks,
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile
          ? [
              {
                documentType: currentAction + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      const appData = {
        ...applicationData,
        // documents: formData?.applicationData?.tradeLicenseDetail?.applicationDocuments ,
        additionalDetails,
        workflow,
        action: currentAction?.action,
        comment: developerRemarks,
        nocOtherDetails: reduxFormData,
        assignee: null,
        wfDocuments: uploadedFile
          ? [
              {
                documentType: currentAction + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      const data = [{ ...appData }];
      updateApiCall.mutate(
        { Licenses: data },
        {
          onSuccess: async (result) => {
            if (result?.Licenses?.length > 0) {
              // const dataToSend = {
              //   RequestInfo: {
              //     apiId: "Rainmaker",
              //     action: "_create",
              //     did: 1,
              //     key: "",
              //     msgId: "20170310130900|en_IN",
              //     ts: 0,
              //     ver: ".01",
              //     authToken: authToken,
              //     userInfo: userInfo,
              //   },
              // };
              // //apply signature validation
              // const Resp = await axios
              //   .post(`${Urls.tl.designOfApproval}?tenantId=${tenantId}&applicationNumber=${applicationData?.applicationNumber}`, dataToSend)
              //   .then((response) => {
              //     return response.data;
              //   });
              Swal.fire({
                title: "Action Applied",
                text: `Application (${result?.Licenses?.[0]?.applicationNumber}) Approved Successfully!`,
                icon: "success",
              });
              const fileStoreId = result?.Licenses?.[0]?.approvalLetterId;
              const fileStoreUrl = result?.Licenses?.[0]?.approvalLetterUrl;
              setStructureCertificateId(fileStoreId);
              setStructureCertificateUrl(fileStoreUrl);
              setShowTakeAction("Take_Action");
              //window.open(Resp?.fileStoreUrl);
              //third API Call
              //await approvalOfLetterSubmit(fileStoreId);
            }
          },
        }
      );
    } catch (error) {
      console.log(error);
    }
  };
  const viewApprovalLetter = (url) => {
    const fileUrl = structureCertificateUrl || url;
    window.open(fileUrl, "_blank");
    Swal.fire({
      title: "Action Approved",
      text: `Application Approved Successfully!`,
      icon: "success",
    }).then(() => {
      window.location.reload();
    });
    history.push("/digit-ui/employee");
  };
  const structuralStabilityPdf = async (currentAction) => {
    if (currentAction?.action === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE") {
      const dataToSend = {
        RequestInfo: {
          apiId: "Rainmaker",
          action: "_create",
          did: 1,
          key: "",
          msgId: "20170310130900|en_IN",
          ts: 0,
          ver: ".01",
          authToken: authToken,
          userInfo: userInfo,
        },
      };
      try {
        const Resp = await axios.post(`${Urls.obps.designOfStuctural}?tenantId=hp&applicationNumber=${id}`, dataToSend).then((response) => {
          return response.data;
        });

        setStructureCertificateId(Resp?.fileStoreId);
        setStructureCertificateUrl(Resp?.fileStoreUrl);
        setShowTakeAction("Take_Action");
        window.open(Resp?.fileStoreUrl);
        // setRemarksData(Resp);
      } catch (error) {
        console.log(error);
      }
    } else {
      console.log("elseNew");
    }
  };
  const approvalOfLetterArchitect = async () => {
    if (actions?.[0]?.action === "ISSUE_CERTIFICATE") {
      const dataToSend = {
        RequestInfo: {
          apiId: "Rainmaker",
          action: "_create",
          did: 1,
          key: "",
          msgId: "20170310130900|en_IN",
          ts: 0,
          ver: ".01",
          authToken: authToken,
          userInfo: userInfo,
        },
      };
      try {
        const Resp = await axios.post(`${Urls.obps.designOfApproval}?tenantId=hp&applicationNumber=${id}`, dataToSend).then((response) => {
          return response.data;
        });

        setStructureCertificateId(Resp?.fileStoreId);
        setStructureCertificateUrl(Resp?.fileStoreUrl);
        setShowTakeAction("Take_Action");
        window.open(Resp?.fileStoreUrl);
        // setRemarksData(Resp);
      } catch (error) {
        console.log(error);
      }
      if (structureCertificateUrl) {
        try {
          const additionalDetails = { ...applicationData?.additionalDetails, fieldinspection_pending: getfeildInspection(applicationData) };
          const workflow = {
            action: "ISSUE_CERTIFICATE",
            comment: "Issue Certificate",
            comments: "Issue Certificate",
            assignee: null,
            assignes: null,
            varificationDocuments: uploadedFile
              ? [
                  {
                    documentType: actions + " DOC",
                    fileName: file?.name,
                    fileStoreId: uploadedFile,
                  },
                ]
              : null,
          };
          const appData = {
            ...applicationData,
            documents: formData?.documents,
            additionalDetails,
            workflow,
            approvalCertificateUrl: structureCertificateUrl,
            approvalCertificateId: structureCertificateId,
            action: "ISSUE_CERTIFICATE",
            comment: "Issue Certificate",
            assignee: null,
            wfDocuments: uploadedFile
              ? [
                  {
                    documentType: actions + " DOC",
                    fileName: file?.name,
                    fileStoreId: uploadedFile,
                  },
                ]
              : null,
          };
          /////
          Digit.OBPSService.update({ BPA: appData }, tenantId).then((result) => {
            if (result?.BPA?.length > 0) {
              setShowToast({
                key: "true",
                error: false,
                message: `Application (${result?.BPA?.[0]?.applicationNo}) Updated Successfully!`,
              });
              setOpenApplicantPopup(true);
              // window.location.assign(`${window.location.origin}/digit-ui/citizen/payment/collect/${`bpa/${result?.BPA?.[0]?.applicationNo}/${tenantId}?tenantId=${tenantId}?flow=${result?.BPA?.[0]?.applicationType}`}`);
            }
          });
        } catch (error) {
          console.log("error", error);
        }
      }
    } else {
      console.log("elseNew");
    }
  };

  const handleChangedata = (e) => {
    // setLoader(false);
    setCurrentActionCertification("showActionCertification");
    onActionSelect(currentAction?.action);
  };

  if (pdfLoading) {
    return <Loader />;
  }

  return (
    <React.Fragment>
      {isNodal && <NewsTicker textForNews={"* Please Fill the checklist then Proceed"} time={"42"} fontSize={"13px"} />}
      <Tabs value={currentTab} onChange={handleChange}>
        {tablist.map(({ label, color }, index) => (
          <Tab label={`${t(label)}`} value={`${index}`} sx={{ textTransform: "none", p: "0 1rem", color }} />
        ))}
      </Tabs>
      <StyledTabPanel value={currentTab} index="0">
        <LTPSummary formData={formData?.applicationData} applicationDocs={applicationDocs} totalAmount={totalAmount} />
      </StyledTabPanel>
      <StyledTabPanel value={currentTab} index="1">
        {user?.info?.type === "EMPLOYEE" && (
          <React.Fragment>
            <EmployeeComponent formData={formData?.applicationData} applicationDocs={applicationDocs} totalAmount={totalAmount} />
          </React.Fragment>
        )}
        {user?.info?.type != "EMPLOYEE" && (
          <Architect formData={formData?.applicationData} applicationDocs={applicationDocs} totalAmount={totalAmount} actions={actions} />
        )}
        {/* Registration Customization  */}
        {((userRoles.includes("BPA_STRUCTURALENGINEER") &&
          workflowDetails?.data?.nextActions?.[0]?.action === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE") ||
          user?.info?.type === "EMPLOYEE") && (
          <div style={{ padding: "10px" }}>
            <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
              <Box gridColumn="span 2">
                <b>Action </b>
              </Box>
              <Box gridColumn="span 10">
                <RadioButtons
                  isMandatory={false}
                  options={filteredRegistrationAction}
                  selectedOption={currentAction}
                  optionsKey="action"
                  onSelect={onRadioActionSelect}
                  style={{ display: "flex", gap: "3rem", margin: 0 }}
                />
              </Box>
              {!["APPROVED", "FORWARD_TO_NODAL"].includes(currentAction?.action) && (
                <Box gridColumn="span 2">
                  <b>Remarks </b>
                </Box>
              )}
              {!["APPROVED", "FORWARD_TO_NODAL"].includes(currentAction?.action) && (
                <Box gridColumn="span 10">
                  <DemoParinted setContent={setDeveloperRemarks} content={developerRemarks}></DemoParinted>
                </Box>
              )}
              {/* {["APPROVED", "FORWARD_TO_NODAL"].includes(currentAction?.action) && (
                  <Box gridColumn="span 2">
                    <b className="compulsoryField">Disclaimer *</b>
                  </Box>
                )}
                {["APPROVED"].includes(currentAction?.action) && (
                  <Box gridColumn="span 10">
                    <b>All the details and documents submitted are ok. Finally Approved.</b>
                  </Box>
                )}
                {currentAction?.action == "FORWARD_TO_NODAL" && (
                  <Box gridColumn="span 10">
                    <b>Payment Verified</b>
                  </Box>
                )} */}
            </Box>
            <Dialog
              open={open}
              onClose={handleClose}
              PaperProps={{
                sx: {
                  borderRadius: "12px", // Rounded corners
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)", // Box shadow for depth
                  padding: "10px", // Extra padding for breathing room
                  //background: 'linear-gradient(135deg, rgba(14, 118, 147, 0.8), rgba(0, 176, 255, 0.8))', // Gradient with teal and light blue
                },
              }}
            >
              {/* Disclaimer title with fancy header */}
              {/* <DialogTitle
                  sx={{
                    color: 'white',
                    background: 'linear-gradient(90deg, rgb(14, 118, 147), rgba(0, 176, 255, 1))',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    fontWeight: 'bold', 
                    display: 'flex',
                    alignItems: 'center', 
                    gap: '8px', 
                  }}
                > */}
              {/* Image */}
              {/* <img
                    src="https://i.imgur.com/CNqKZu3.jpeg"
                    alt="Disclaimer icon"
                    style={{
                      width: '70px', // Adjust the image width
                      height: '30px', // Adjust the image height
                      borderRadius: '50%', // Optional: make the image circular
                    }}
                  /> */}

              {/* Text */}
              {/* Disclaimer<span className="compulsoryField">*</span> */}
              {/* </DialogTitle> */}

              {/* Content text with fancier styling */}
              <DialogContent>
                <DialogContentText
                  sx={{
                    color: "black",
                    fontSize: "1rem", // Slightly larger text size
                    padding: "8px 0", // Add padding inside the content
                    marginTop: "-10px",
                  }}
                >
                  {currentAction?.action === "APPROVED" ? "All the details and documents are ok. Approved." : "Payment has been verified."}
                </DialogContentText>
              </DialogContent>

              <DialogActions>
                {/* Fancy button */}
                <Button
                  onClick={handleClose}
                  sx={{
                    backgroundColor: "rgb(14, 118, 147)", // Teal button color
                    color: "#fff",
                    fontWeight: "bold",
                    padding: "8px 16px",
                    borderRadius: "8px",
                    "&:hover": {
                      backgroundColor: "#0e7693", // Slightly darker shade on hover
                    },
                  }}
                >
                  Accept
                </Button>
              </DialogActions>
            </Dialog>

            {currentAction?.action === "ISSUE_CERTIFICATE" && (
              <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                <Box gridColumn="span 2">
                  <b>Insert Conditions if any </b>
                </Box>
                <Box gridColumn="span 10">
                  <RadioButtons
                    style={{ display: "flex", gap: "3rem", margin: 0 }}
                    labelKey="PT_OWNERSHIP"
                    // isDependent={true}
                    isMandatory={false}
                    options={typeOfLandVolvedList}
                    selectedOption={typeOfLandVolved}
                    optionsKey="i18nKey"
                    onSelect={selectedValueSelect}
                  />
                </Box>
              </Box>
            )}

            {typeOfLandVolved?.code === "YES" && (
              <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                <Box gridColumn="span 2"> </Box>
                <Box gridColumn="span 10">
                  {" "}
                  <Addmoreinput
                    applicationimp={formData}
                    applicationStatusRespon={formData?.status}
                    checkBoxValue={typeOfLandVolved?.code}
                  ></Addmoreinput>
                </Box>
              </Box>
            )}
            {/* {typeOfLandVolved?.code  && currentAction?.action === "ISSUE_CERTIFICATE" && ( */}

            {/* Document visiblity - removing document */}
            {/* <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
              <Box gridColumn="span 2"> Document /Certificate</Box>
              <Box gridColumn="span 10">
                <UploadFile
                  id={"workflow-doc"}
                  onUpload={selectFile}
                  onDelete={() => {
                    setUploadedFile(null);
                  }}
                  message={uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`)}
                  accept="image/*, .pdf, .png, .jpeg, .jpg"
                  iserror={error}
                />
              </Box>
            </Box> */}
            {/* )} */}
            <div style={{ marginLeft: "180px", marginTop: "20px" }}>
              {(formData?.applicationData?.status === "APPROVED" || showTakeAction === "Take_Action") && (
                <Button
                  variant="contained"
                  color="success"
                  style={{ marginLeft: "10px" }}
                  onClick={() => viewApprovalLetter(formData?.applicationData?.approvalLetterUrl)}
                >
                  View Approval Letter
                </Button>
              )}
            </div>

            {currentAction && (
              <Card style={{ marginTop: "15px" }}>
                <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                  <Box gridColumn="span 2"></Box>
                  <Box gridColumn="span 10">
                    {currentAction?.action === "APPROVED" && showTakeAction !== "Take_Action" && (
                      <Button
                        variant="contained"
                        color="success"
                        style={{ marginLeft: "10px", fontSize: "12px" }}
                        onClick={() => approvalOfLetterPdf(currentAction)}
                      >
                        Submit
                      </Button>
                    )}
                    {/* {currentAction?.action != "REVERT_TO_APPLICANT" && currentAction?.action != "ISSUE_CERTIFICATE" && currentAction?.action != "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && (
                  <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={submit}>Submit</Button>
                       )} */}
                    {/* {currentAction?.action === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && (
                      <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={() => structuralStabilityPdf(currentAction)}>View Structural Stability Certificate<FileDownloadIcon /></Button>
                    )}
                    {currentAction?.action === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && showTakeAction === "Take_Action" && (
                      <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={structuralStabilitySubmit}>Submit</Button>
                    )} */}
                    {currentAction?.action !== "APPROVED" && (
                      <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={submit}>
                        Submit
                      </Button>
                    )}
                  </Box>
                  {/* <Box gridColumn="span 2">
                  <Button variant="contained" color="success" >Save As Draft</Button>
                </Box> */}
                </Box>
              </Card>
            )}
          </div>
        )}
        {(userRoles.includes("BPA_ARCHITECT") ||
          userRoles.includes("BPA_TOWNPLANNER") ||
          userRoles.includes("BPA_ENGINEER") ||
          userRoles.includes("BPA_ARCHITECT_ASSISTANT") ||
          userRoles.includes("BPA_ENGINEER_DIPLOMA") ||
          userRoles.includes("BPA_DRAUGHTSMAN") ||
          userRoles.includes("BPA_SURVEYOR")) &&
          user?.info?.type === "CITIZEN" && (
            <React.Fragment>
              {actions?.[0]?.action === "MAKE_PAYMENT" && (
                <div style={{ marginTop: "15px" }}>
                  <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                    <Box gridColumn="span 2"></Box>
                    <Box gridColumn="span 8"></Box>
                    <Box gridColumn="span 2">
                      <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={handleChangePayment}>
                        Payment
                      </Button>
                    </Box>
                  </Box>
                </div>
              )}
              {actions?.[0]?.action === "MAKE_PAYMENT_APPLICATION_FEE" && (
                <div style={{ marginTop: "15px" }}>
                  <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                    <Box gridColumn="span 2"></Box>
                    <Box gridColumn="span 8"></Box>
                    <Box gridColumn="span 2">
                      <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={handleChangePayment}>
                        Payment
                      </Button>
                    </Box>
                  </Box>
                </div>
              )}
              {formData?.plotArea < 500 &&
                formData?.typeofArea === "Residential" &&
                actions?.[0]?.action === "UPLOAD_SITE_INSPECTION_REPORT" &&
                twentyFourHoursPassed && (
                  <div style={{ marginTop: "15px" }}>
                    <div style={{ marginBottom: "5px" }}>
                      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                        <Box gridColumn="span 4">Upload site Inspection Report</Box>
                        <Box gridColumn="span 8">
                          <UploadFile
                            id={"workflow-doc"}
                            onUpload={selectFile}
                            onDelete={() => {
                              setUploadedFile(null);
                            }}
                            message={uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`)}
                            accept="image/*, .pdf, .png, .jpeg, .jpg"
                            iserror={error}
                          />
                        </Box>
                      </Box>
                    </div>

                    <div>
                      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                        <Box gridColumn="span 2"></Box>
                        <Box gridColumn="span 6"></Box>
                        <Box gridColumn="span 4">
                          <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={handleChangeForward}>
                            Submit Inspection Report{" "}
                          </Button>
                        </Box>
                      </Box>
                    </div>
                  </div>
                )}
              {formData?.plotArea < 500 && formData?.typeofArea === "Residential" && actions?.[0]?.action === "ISSUE_CERTIFICATE" && (
                <div style={{ marginTop: "15px" }}>
                  <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                    <Box gridColumn="span 2"></Box>
                    <Box gridColumn="span 8"></Box>
                    <Box gridColumn="span 2">
                      <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={approvalOfLetterArchitect}>
                        Self Approval
                      </Button>
                    </Box>
                  </Box>
                </div>
              )}
              {formData?.plotArea < 500 && formData?.typeofArea === "Residential" && actions?.[1]?.action === "MAKE_PAYMENT" && (
                <div style={{ marginTop: "15px" }}>
                  <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                    <Box gridColumn="span 2"></Box>
                    <Box gridColumn="span 8"></Box>
                    <Box gridColumn="span 2">
                      <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={handleChangePaymentTCP}>
                        Payment
                      </Button>
                    </Box>
                  </Box>
                </div>
              )}
              {formData?.plotArea > 500 && actions?.[0]?.action === "FORWARD_TO_DEPARTMENT" && (
                <div style={{ marginTop: "15px" }}>
                  <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                    <Box gridColumn="span 2"></Box>
                    <Box gridColumn="span 6"></Box>
                    <Box gridColumn="span 4">
                      <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={handleChangeForward}>
                        Forward To Department
                      </Button>
                    </Box>
                  </Box>
                </div>
              )}
            </React.Fragment>
          )}
      </StyledTabPanel>
      <StyledTabPanel value={currentTab} index="2">
        {showTimeLine && workflowDetails?.data?.timeline?.length > 0 && (
          <React.Fragment>
            <BreakLine />
            {(workflowDetails?.isLoading || isDataLoading) && <Loader />}
            {!workflowDetails?.isLoading && !isDataLoading && (
              <Fragment>
                <CardSectionHeader style={{ marginBottom: "16px", marginTop: "32px" }}>
                  {t("ES_APPLICATION_DETAILS_APPLICATION_ALL_REMARKS")}
                </CardSectionHeader>
                {workflowDetails?.data?.timeline && workflowDetails?.data?.timeline?.length === 1 ? (
                  <Card style={{ backgroundColor: "aliceblue", borderRadius: "20px" }}>
                    <CheckPoint
                      isCompleted={true}
                      label={t(`${timelineStatusPrefix}${workflowDetails?.data?.timeline[0]?.state}`)}
                      customChild={getTimelineCaptions(workflowDetails?.data?.timeline[0])}
                    />
                  </Card>
                ) : (
                  <ConnectingCheckPoints>
                    {workflowDetails?.data?.timeline &&
                      [...new Set(workflowDetails.data.timeline.map((checkpoint) => checkpoint?.status))].map((uniqueStatus, index) => {
                        // Filter the timeline for checkpoints with the unique status
                        const checkpoint = workflowDetails.data.timeline.find((item) => item.status === uniqueStatus);
                        return (
                          <React.Fragment key={index}>
                            <Card style={{ backgroundColor: "aliceblue", borderRadius: "20px" }}>
                              <CheckPoint
                                keyValue={index}
                                isCompleted={index === 0}
                                info={checkpoint?.comment}
                                label={t(
                                  `${timelineStatusPrefix}${
                                    checkpoint?.performedAction === "REOPEN" ? checkpoint?.performedAction : checkpoint?.[statusAttribute]
                                  }`
                                )}
                                customChild={getTimelineCaptions(checkpoint)}
                              />
                            </Card>
                          </React.Fragment>
                        );
                      })}
                  </ConnectingCheckPoints>
                )}
              </Fragment>
            )}
          </React.Fragment>
        )}
      </StyledTabPanel>

      <StyledTabPanel value={currentTab} index="3">
        <LTPCheckList formData={formData?.applicationData} />
      </StyledTabPanel>
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
      {/* changes here */}
      <Dialog open={openApplicantPopup} onClose={handleModal} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" style={{ textAlign: "center", fontSize: "35px" }}>
          Thanks You!{" "}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <p>
              <CheckCircleOutlineIcon style={{ color: "green", variant: "filled", margin: "0px 40% 0", fontSize: "100px", padding: "2px" }} />
            </p>
            <p style={{ textAlign: "center", fontSize: "15px" }}>
              <p>Your Action Has been Completed. Please Note Down </p>
              {/* <p>{userRolesArray?.[0]?.code}</p>  */}
              <p>{formData?.applicationType} ( Building Plan Approval)</p>
              <p>
                {" "}
                Application no <span style={{ padding: "5px", color: "blue" }}>{id}</span> is Done Successfully.{" "}
              </p>
            </p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleModal} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default ProfessionalFormSummary;
